import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { toSelected } from "./logic";
import { columnas } from "./columns";

export interface Props {
    /**Folios de las guias seleccionadass¿ */
    value: number[];
    onChange: (value: number[]) => void;
    items: models.EntregaZERealizadaDTO[];
    hideBusqueda?: boolean;
    label?: string;
}

/**Multiselector de las guias, lo unico que muestra es el grid, no muestra los filtros ni ninguna otra cosa  */
class MultiselectorEntregasListNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    items = (props: Props) => props.items;
    itemsSelected = createSelectorRx(this.value, this.items, (value, items) => toSelected(items, value));

    onSeleccionar = (guia: models.EntregaZERealizadaDTO, selected: boolean) => {
        const old = this.value(this.props);
        const next = selected ? [...old, guia.IdRegistro] : old.filter(x => x != guia.IdRegistro);

        this.props.onChange(next);
    };

    onVer = (guia: models.EntregaZERealizadaDTO) => {
        history.go("/operativa/entregasZERealizadas/" + guia.IdRegistro);
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                {this.props.label && <kea.Title titulo={this.props.label} size="h4" />}
                <kea.Grid2 cookieKey="MultiselectorEntregasList" items={this.itemsSelected(this.props)} columnas={cols} hideBusqueda={this.props.hideBusqueda} />
            </div>
        );
    }
}

export const MultiselectorEntregasList = componentToRx(MultiselectorEntregasListNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/multientregas/list.tsx